import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CampaignService } from './approval/campaign';
import { MsalGuard } from '@azure/msal-angular';
import { AccessDeniedComponent } from './access-denied/access-denied.component';

const menuApps = [
  {
    icon: 'fas fa-plus-square',
    name: 'Add Offer'
  },
  {
    icon: 'fas fa-clone',
    name: 'Clone'
  },
  {
    icon: 'fas fa-edit',
    name: 'Edit'
  }
];
const appRoutes: Routes = [
  

  {
    path: '',
    redirectTo: 'main',
    pathMatch: 'full'
  },

  {
    path: 'dealerOnBoarding',
    loadChildren:
      () => import('./dashboard/dealer-on-boarding/dealer-on-boarding.module').then(m => m.DealerOnBoardingModule),
    canActivate: [MsalGuard]
  },
  {
    path: 'dealers',
    loadChildren: () => import('./dashboard/admin/dealers/dealers.module').then(m => m.DealersModule),
    canActivate: [MsalGuard]
  },
  {
    path: 'dealers/boarding',
    loadChildren: () => import('./dashboard/admin/dealers/dealers.module').then(m => m.DealersModule),
    canActivate: [MsalGuard]
  },
  {
    path: 'floodlights',
    loadChildren: () => import('./dashboard/admin/floodlights/floodlights.module').then(m => m.FloodlightsModule),
    canActivate: [MsalGuard]
  },
  {
    path: 'email-sms-backup',
    loadChildren: () => import('./dashboard/admin/email-sms-backup/email-sms-backup.module').then(m => m.EmailSmsBackupModule),
    canActivate: [MsalGuard]
  },
  {
    path: 'cost',
    loadChildren: () => import('./dashboard/admin/cost/cost.module').then(m => m.CostModule),
    canActivate: [MsalGuard]
  },
  {
    path: 'users',
    loadChildren: () => import('./dashboard/admin/users/users.module').then(m => m.UsersModule),
    canActivate: [MsalGuard],
    data: { roles: [] }
  },
  {
    path: 'api-status',
    loadChildren: () => import('./api-status/api-status.module').then(m => m.ApiStatusModule)
  },
  {
    path: 'main',
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [MsalGuard]
  },
  {
    path: 'dcedashboard',
    loadChildren: () => import('./dcedashboard/dcedashboard.module').then(m => m.DcedashboardModule),
    canActivate: [MsalGuard]
  },
  {
    path: 'success/:id',
    loadChildren: () => import('./ads-success/ads-success.module').then(m => m.AdsSuccessModule),
    canActivate: [MsalGuard]
  },
  { 
    path: 'access-denied', 
    component: AccessDeniedComponent 
  },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { initialNavigation: 'enabledBlocking' })],
  exports: [RouterModule],
  providers: [CampaignService]
})
export class AppRoutingModule {}
